import { render } from "./CalendarR.vue?vue&type=template&id=79c4bdf3&scoped=true"
import script from "./CalendarR.vue?vue&type=script&lang=js"
export * from "./CalendarR.vue?vue&type=script&lang=js"

import "./CalendarR.vue?vue&type=style&index=0&id=79c4bdf3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c4bdf3"]])

export default __exports__